import restfulBase from '@/services/negotiations/core/base';

export const contractsService = (companyId: string) =>
  restfulBase(`companies/${companyId}/contracts`);

export default contractsService;
